<!--
 * @LastEditors: chg
 * @desc: 重构公式 - 代码编辑器codemirror输入框
 * @场景: 使用F1会打开重构公式 抽屉
-->
<template>
  <div style="CodeMirror">
    <div>
      <textarea id="factor" ref="mycode" v-model="code"></textarea>
      <!-- <textarea style="position: absolute;left: 0;display: block;" id="factor" ref="mycode" v-model="code" ></textarea> -->
    </div>
  </div>
</template>

<script>
import { getRequest } from '@/api/dailyBackTest.js'
import { getTimeSeriesRequest } from '@/api/timeSeries.js'

// import myMirrorTools from './controller/myMirror.js'
// import '../chonggou/chonggou'
import 'codemirror/theme/idea.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/hint/show-hint.css'
const CodeMirror = require('codemirror/lib/codemirror')
require('codemirror/addon/edit/matchbrackets')
// 高亮行功能
require('codemirror/addon/selection/active-line')
require('codemirror/addon/selection/selection-pointer')
// require('../chonggou/chonggou')
// require('codemirror/mode/chonggou/chonggou')
require('codemirror/addon/hint/show-hint')
require('codemirror/addon/hint/anyword-hint')
require('codemirror/addon/hint/sql-hint')

export default {
  name: 'in-coder',
  props: ['factorTextarea', 'utilityAssetList', 'functionGroupList', 'tickerInfoList', 'indexInfoList', 'keyWord'],
  // 外部传入的内容，用于实现双向绑定
  watch: {
    factorTextarea (newVal, oldVal) {
      if (!this.updatingFromEditor && this.editor) {
        this.editor.setValue(newVal)
      }
      this.updatingFromEditor = false
    },
    tickerInfoList (newVal) {
      this.tickerList = newVal
    },
    indexInfoList (newVal) {
      this.infoList = newVal
    },
    keyWord (newVal) {
      // 初始化
      this._initialize()
    }
  },
  data () {
    return {
      code: '',
      factorItem: '',
      factorHistoryLength: '',
      selectOptions: [],
      patrnKey: [],
      editor: null,
      content: '',
      showBtn: '',
      codeEditorRef: '',
      keyWords: [],
      zcList: [
        'ret',
        '取回报率',
        'close',
        '收盘价',
        'open',
        '开盘价',
        'pick',
        '取出',
        'high',
        '最高价',
        'low',
        '最低价',
        'buildSector',
        '板块构造',
        'asset',
        '资产'
      ],
      bkList: [
        'sector',
        '板块',
        'sectorRet',
        '板块回报率'
      ],
      timer: '',
      tickerList: {},
      infoList: {},
      sectorList: {},
      is_paste: false,
      updatingFromEditor: false
    }
  },
  mounted () {
    // 初始化
    if (this.keyWord.length > 0) {
      this._initialize()
    }
    // var _this = this
    // this.bus.$on('factor', (value) => {
    //   // 保存当前光标位置
    //   const currentCursor = this.editor.getCursor()

    //   // 设置新值
    //   _this.editor.setValue(value)

    //   // 恢复光标位置
    //   _this.editor.setCursor(currentCursor)
    // })
    this.code = this.factorTextarea
  },
  methods: {
    // 父组件调用清空的方法
    resetData () {
      this.editor.setValue('')
    },
    parseWords (words) {
      var obj = {}
      // words = str.split(' ');
      for (var i = 0; i < words.length; ++i) obj[words[i]] = true
      return obj
    },
    // 初始化
    _initialize () {
      const mime = 'chonggou'
      var _this = this
      this.codeEditorRef = this.$refs.mycode
      // let theme = 'ambiance'//设置主题，不设置的会使用默认主题
      CodeMirror.defineMode('chonggou', (config, parserConfig) => {
        var jsonldMode = parserConfig.jsonld
        // 该正则表达式匹配以下字符之一：+、-、*、&、%、=、)、<、>、!、?、|、~、^、@、(。
        var isOperatorChar = /[+\-*&%=)<>!?|~^@(]/
        var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/
        var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/

        function parseWords (words) {
          var obj = {}
          // words = str.split(' ');
          for (var i = 0; i < words.length; ++i) obj[words[i]] = true
          return obj
        }
        var keywords = parseWords(_this.keyWord)
        // console.log(keywords)
        // 关键字
        // var type
        // var content
        function ret (tp, style, cont) {
          // type = tp
          // content = cont
          return style
        }

        function tokenBase (stream, state) {
          var ch = stream.next()
          if (ch === '"' || ch === "'") {
            state.tokenize = tokenString(ch)
            return state.tokenize(stream, state)
          } else if (ch === '.' && stream.match(/^\d[\d_]*(?:[eE][+-]?[\d_]+)?/)) {
            return ret('number', 'number')
          } else if (/[[]{}(),，（）;:.]/.test(ch)) {
            return ret(ch)
          } else if (ch === '=' && stream.eat('>')) {
            return ret('=>', 'operator')
          } else if (ch === '0' && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) {
            return ret('number', 'number')
          } else if (/\d/.test(ch)) {
            stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+-]?[\d_]+)?)?/)
            return ret('number', 'number')
          } else if (ch === '/') {
            if (stream.eat('/')) {
              stream.skipToEnd()
              return ret('comment', 'comment')
            } else {
              stream.eat('=')
              return ret('operator', 'operator', stream.current())
            }
          } else if (isOperatorChar.test(ch)) {
            if (ch !== '>' || !state.lexical || state.lexical.type !== '>') {
              if (stream.eat('=')) {
                if (ch === '!' || ch === '=') stream.eat('=')
              } else if (/[<>*+\-|&?（]/.test(ch)) {
                stream.eat(ch)
                if (ch === '>') stream.eat(ch)
              }
            }
            if (ch === '?' && stream.eat('.')) return ret('.')
            return ret('operator', 'operator', stream.current())
          } else if (wordRE.test(ch)) {
            stream.eatWhile(wordRE)
            var word = stream.current()
            if (keywords && keywords.propertyIsEnumerable(word)) {
              state.beforeParams = true
              return 'keyword'
            }
            return ret('variable', 'variable', word)
          } else {
            return null
          }
        }

        function tokenString (quote) {
          return function (stream, state) {
            var escaped = false
            var next
            if (jsonldMode && stream.peek() === '@' && stream.match(isJsonldKeyword)) {
              state.tokenize = tokenBase
              return ret('jsonld-keyword', 'meta')
            }
            while ((next = stream.next()) != null) {
              if (next === quote && !escaped) break
              escaped = !escaped && next === '\\'
            }
            if (!escaped) state.tokenize = tokenBase
            return ret('string', 'string')
          }
        }

        return {
          startState: function () {
            return {
              tokenize: tokenBase,
              beforeParams: false,
              inParams: false
            }
          },
          token: function (stream, state) {
            if (stream.eatSpace()) return null
            return state.tokenize(stream, state)
          }
        }
      })

      // 自定义语言模式
      CodeMirror.defineMIME('text/x-chonggou', {
        name: 'chonggou'
      })

      this.editor = CodeMirror.fromTextArea(this.$refs.mycode, {
        // 选择对应代码编辑器的语言，我这边选的是数据库，根据个人情况自行设置即可
        mode: mime,
        theme: 'idea', // 设置主题
        indentWithTabs: true,
        smartIndent: true,
        lineNumbers: true, // 显示行号
        matchBrackets: true, // 括号匹配
        lineWrapping: true,
        // completeOnSingleClick: false,
        extraKeys: {
          // 触发提示按键
          Ctrl: 'autocomplete'
        },
        hintOptions: {
          // 自定义提示选项
          // updateOnCursorActivity: false,
          async: true,
          completeSingle: false, // 当匹配只有一项的时候是否自动补全
          hint: _this.handleShowHint // 输入框搜索下拉
          // tables: this.hintobj // 代码提示
        }
      })
      this.editor.setValue(this.value || this.code)

      // 在 CodeMirror 中，change 事件是在编辑器内容发生更改时触发的事件。当用户对编辑器进行编辑操作时（例如输入、删除、剪切、粘贴等），change 事件将被触发。
      // coder：编辑器实例 changeObj：是一个描述编辑器内容更改的对象。
      this.editor.on('change', (coder, changeObj) => {
        this.updatingFromEditor = true
        this.is_paste = false
        if (changeObj.origin === 'paste') {
          this.is_paste = true
          this.patrnKey = changeObj.text
          this.editor.showHint()
        }

        // 获取当前编辑器中的文本内容
        this.code = coder.getValue()
        // console.log('this.editor.on ~ this.code >>>>>>>:', this.code)
        this.checkBracketsAndHighlight(this.editor)
        this.$emit('update:factorTextarea', this.code)
      })
      this.editor.on('keyHandled', (instance, name) => {
        if (name === 'Backspace' || name === 'Delete') {
          this.editor.showHint()
        }
      })
      this.editor.on('inputRead', () => {
        // this.debounce(_this.editor.showHint())
        this.editor.showHint()
      })
      document.getElementById('factor').addEventListener('paste', function (event) {
        var clipText = event.clipboardData.getData('Text')
        _this.patrnKey = [clipText]
      })
      // this.editor.on('cursorActivity', () => {
      //   // this.debounce(_this.editor.showHint())
      //   this.editor.showHint()
      // })
      // Do something with the selectedItem.
      // This function would be called after user pick a item from the list.
    },
    getKeywords (editor) {
      var mode = editor.doc.modeOption
      mode = 'text/x-chonggou'
      return CodeMirror.resolveMode(mode).keywords
    },
    debounce (cursorLine, end) {
      // 每次按下键盘的时候都会触发这个函数，
      // 先清除定时器然后再设置定时器，他就会从新开始计时return (...args: any) =>
      return new Promise((resolve, reject) => {
        clearTimeout(this.timer)
        this.timer = setTimeout(async () => {
          try {
            const res = await this.querySearchTextarea(cursorLine, end)
            resolve(res)
          } catch (error) {
            reject(error)
          }
        }, 500)
      })
    },
    async handleShowHint (cmInstance, hintOptions) {
      // 得到光标
      let cursor = cmInstance.getCursor()
      // 得到行内容
      let cursorLine = cmInstance.getLine(cursor.line)
      // 得到光标位置
      let end = cursor.ch
      // 得到行内容
      // let token = cmInstance.getTokenAt(cursor)
      // let start = token.start
      var list = []
      if (!this.is_paste) {
        this.patrnKey = cursorLine.substring(0, end).split(/[-+*()（） /"“,，><=]/)
      }
      list = await this.debounce(cursorLine, end)
      let startFactor = cursorLine.substring(0, end)
      let key = this.patrnKey[this.patrnKey.length - 1]
      let start = startFactor.lastIndexOf(key)
      // console.log(start)
      if (this.code.charAt(start - 1) === '"') {
        start = start - 1
      }
      var completion = {
        list: list,
        from: {ch: start, line: cursor.line},
        to: {ch: end, line: cursor.line}
      }
      // console.log(completion)
      CodeMirror.on(completion, 'pick', (coder) => {
        this.handleSelectTextarea(coder)
      })
      return completion
    },
    handleSelectTextarea (item) {
      var key = this.patrnKey[this.patrnKey.length - 1]
      if (!this.tickerList) {
        this.tickerList = {}
      }
      if (item.asset_type && item.asset_type === 'stock_info') {
        if (item.code.indexOf(key.toUpperCase()) > -1) {
          this.tickerList[item.code] = item.ticker
        } else {
          this.tickerList[item.name] = item.ticker
        }
      } else if (item.asset_type && item.asset_type === 'index_info') {
        this.infoList[item.index_title] = item._id
      } else if (item.data_type === 'index_info') {
        this.infoList[item.index_title] = item._id
      } else if (item.data_type === 'tag_info') {
        this.infoList[item.index_title] = item._id
      } else if (item.tagName) {
        this.sectorList[item.tagName] = item.tag
      }
      this.$emit('keyList', this.tickerList, this.infoList, this.sectorList)
    },
    getTickerName (data) {
      // let list = []
      for (let i = 0; i < data.length; i++) {
        data[i].text = data.name
        data[i].displayText = data.tagName
      }
      return data
    },
    createFilters (queryString) {
      return (restaurant) => {
        return (restaurant.tagName.toLowerCase().indexOf(queryString.toString().toLowerCase()) > -1)
      }
    },
    async querySearchTextarea (cursorLine, startPos) {
      var _this = this
      this.factorItem = this.code
      var results = []
      let key = this.patrnKey[this.patrnKey.length - 1]
      if (key.length < 1) {
        return results
      }
      if (this.bkList.indexOf(this.patrnKey[this.patrnKey.length - 2]) > -1) {
        let restaurants = this.utilityAssetList
        let result = []
        result = key ? restaurants.filter(this.createFilters(key)) : restaurants
        for (let i = 0; i < result.length; i++) {
          result[i].text = result[i].tagName
          result[i].displayText = result[i].tagName
        }
        return result
      } else if (this.findIndexInZcList(this.patrnKey, this.zcList)) {
        let index = this.findIndexInZcList(this.patrnKey, this.zcList)
        var x = await getRequest('/ticker/getAssetList', {key: key})
        if (!x.data.message) {
          results = x.data.data
          let result = []
          if (_this.zcList[index] === '收盘价' || _this.zcList[index] === 'close') {
            for (let i = 0; i < results.length; i++) {
              if (results[i].asset_type && results[i].asset_type !== 'index_info') {
                results[i].text = results[i].name
                results[i].displayText = results[i].name + ' - ' + results[i].ticker
                result.push(results[i])
              }
            }
          } else {
            for (let i = 0; i < results.length; i++) {
              if (results[i].asset_type && results[i].asset_type === 'index_info') {
                results[i].text = results[i].index_title
                results[i].displayText = results[i].index_title
              } else {
                results[i].text = results[i].name
                results[i].displayText = results[i].name + ' - ' + results[i].ticker
              }
              result.push(results[i])
            }
          }
          return result
        }
      } else if (this.patrnKey[this.patrnKey.length - 2] === '资产池收盘价' || this.patrnKey[this.patrnKey.length - 2] === 'multiClose') {
        x = await getRequest('/customLabel/getLableName', {keyword: key})
        if (!x.data.message) {
          results = x.data.data
          for (let i = 0; i < results.length; i++) {
            results[i].text = results[i].lable_name
            results[i].displayText = results[i].lable_name
          }
          return results
        }
      } else {
        x = await getTimeSeriesRequest('dataAndTagSearch', {key: key, fields: 'indexinfo'})
        if (!x.data.message) {
          results = x.data.data.search_data
          // let list = []
          for (let i = 0; i < results.length; i++) {
            if (results[i].tagName) {
              results[i].text = results[i].tagName
              results[i].displayText = results[i].tagName
            } else if (results[i].data_type && results[i].data_type === 'func_info') {
              results[i].text = results[i].format.split('，').join(',')
              results[i].displayText = results[i].title_chinese + ' - ' + results[i].title + ' - ' + results[i].format
            } else if (results[i].data_type && results[i].data_type === 'index_info') {
              results[i].text = '"' + results[i].index_title + '"'
              let min = ''
              let max = ''
              if (results[i].min_value < -100000000 || results[i].min_value > 100000000) {
                min = Math.round(results[i].min_value / 1000000) / 100 + '亿 ~ '
              } else if (results[i].min_value < -10000 || results[i].min_value > 10000) {
                min = Math.round(results[i].min_value / 100) / 100 + '万 ~ '
              } else {
                min = Math.round(results[i].min_value * 100) / 100 + '~'
              }
              if (results[i].max_value > 100000000 || results[i].max_value < -100000000) {
                max = Math.round(results[i].max_value / 1000000) / 100 + '亿'
              } else if (results[i].max_value > 10000 || results[i].max_value < -10000) {
                max = Math.round(results[i].max_value / 100) / 100 + '万'
              } else {
                max = Math.round(results[i].max_value * 100) / 100
              }
              let name = ''
              if (results[i].user_info) {
                name = results[i].user_info.realName
              } else {
                name = results[i].index_source_name
              }
              if (results[i].table_name) {
                results[i].displayText = results[i].index_title + ' - ' + min + max + ' - ' + name + ' - ' + results[i].table_name
              } else {
                results[i].displayText = results[i].index_title + ' - ' + min + max + ' - ' + name
              }
            } else if (results[i].asset_type && results[i].asset_type === 'stock_info') {
              results[i].text = results[i].name
              results[i].displayText = results[i].code + ' - ' + results[i].name
            } else if (results[i].asset_type && results[i].asset_type === 'index_info') {
              results[i].text = results[i].index_title
              results[i].displayText = results[i].index_title
            } else {
              let text = results
              results[i] = {}
              results[i].text = text
              results[i].displayText = text
              // list.push(results[i])
            }
          }
          return results
        }
      }
      // 调用 callback 返回建议列表的数据
    },
    hintobj (val) {
      // 动态设置tables参数
      this.editor.setOption('hintOptions', {
        completeSingle: false,
        // 自定义提示选项
        tables: val
      })
    },

    // 查找数组中元素的索引
    findIndexInZcList (arr, zcList) {
      // 从 arr 数组的末尾开始遍历
      for (let i = arr.length - 1; i >= 0; i--) {
        // 获取当前元素在 zcList 中的索引
        let index = zcList.indexOf(arr[i])
        // 如果当前元素在 zcList 中存在，则返回其索引
        if (index !== -1) {
          return index
        }
      }
      // 如果没有找到匹配的元素，返回 null
      return null
    },

    // 检查括号是否匹配，并高亮未闭合的括号
    checkBracketsAndHighlight (editor) {
      const bracketsMap = { '(': ')', '（': '）', '[': ']', '{': '}' }

      const text = editor.getValue()
      const stack = []
      const positions = []

      // 遍历文本并检查括号
      for (let i = 0; i < text.length; i++) {
        const char = text[i]
        if (bracketsMap[char]) {
          stack.push({ char, position: i })
        } else if (Object.values(bracketsMap).includes(char)) {
          if (stack.length === 0 || bracketsMap[stack[stack.length - 1].char] !== char) {
            positions.push(i)
          } else {
            stack.pop()
          }
        }
      }

      // 高亮未闭合的括号
      stack.forEach(item => positions.push(item.position))
      editor.getAllMarks().forEach(mark => mark.clear())
      positions.forEach(position => {
        editor.markText({ line: editor.posFromIndex(position).line, ch: position },
          { line: editor.posFromIndex(position).line, ch: position + 1 },
          { className: 'highlight-line' })
      })
    }

  }
}
</script>

<style>
.CodeMirror {
  width: 100%;
  height: 200px !important;
  background-color: #F7F7F7 !important;
  border-radius: 7px 7px 7px 7px;
  flex-grow: 1;
  z-index: 1;
}
.in-coder-panel {
  border-radius: 5px;
  flex-grow: 1;
  display: flex;
  position: relative;
  text-align: left;
}
.in-coder-panel .cm-variable {
  font-size: 18px;
}
.CodeMirror-code {
  line-height: 19px;
}
.code-mode-select {
  position: absolute;
  z-index: 2;
  right: 10px;
  top: 10px;
  max-width: 130px;
}
.CodeMirror-hints {
  z-index: 999999 !important;
  display: flex;
  flex-direction: column;
  left: 10px !important;
}

.highlight-line {
  background-color: yellow;
  color: red !important;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/myMirror.vue